import { render, staticRenderFns } from "./EventsContainer.vue?vue&type=template&id=ee93de6e"
import script from "./EventsContainer.vue?vue&type=script&lang=js"
export * from "./EventsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports